import { Banner as BannerUI, Container } from '@tryhackme/thm-ui-components';
import { useParams } from 'react-router-dom';
import { SEO } from 'src/common/components';
import { MODULE_JSON_LD_BASE_SCHEMA } from 'src/common/components/seo/seo.constants';
import { MAIN_DOMAIN_URL } from 'src/common/constants';
import { ComplexRoomBox } from 'src/features/room/components/complex-room-box';
import { RoomDetailsData } from 'src/features/room/room.types';
import { Banner, MainContent } from './components';
import { defaultModuleData } from './module.constants';
import { useGetModuleQuery, useGetModuleScoreboardQuery } from './module.slice';
import { StyledMainContentOuter } from './components/module.styles';
export const Module = () => {
  const {
    moduleURL: moduleURLParam
  } = useParams();
  const {
    data: moduleData,
    isLoading
  } = useGetModuleQuery(moduleURLParam ?? '', {
    skip: !moduleURLParam
  });
  const module = moduleData?.data ?? defaultModuleData;
  const {
    data: moduleScoreboard
  } = useGetModuleScoreboardQuery({
    roomCodes: module.rooms.map(room => room.code).join(','),
    limit: 10
  }, {
    skip: !moduleData?.data?.ctf
  });
  const {
    title,
    summary,
    description,
    image,
    moduleURL,
    difficultyLevel,
    rooms,
    prerequisites,
    nextSteps,
    ctf,
    mitreAssignment
  } = module;
  if (isLoading) {
    return <BannerUI />;
  }
  return <>
      <SEO title={title} titleSuffix="Training" description={description} imageURL={image} jsonLd={{
      ...MODULE_JSON_LD_BASE_SCHEMA,
      image: [image],
      educationalLevel: difficultyLevel === 1 ? 'Beginner' : 'Intermediate',
      name: title,
      description,
      provider: {
        '@type': 'Organization',
        name: 'TryHackMe',
        sameAs: `${MAIN_DOMAIN_URL}/module/${moduleURL}`
      }
    }} data-sentry-element="SEO" data-sentry-source-file="module.tsx" />
      <Banner title={title} description={description} summary={summary} image={image} isCtfModule={ctf} data-sentry-element="Banner" data-sentry-source-file="module.tsx" />
      {ctf && <StyledMainContentOuter>
          <Container>
            <ComplexRoomBox roomDetails={({
          simpleRoom: false
        } as RoomDetailsData)} isModuleScoreboard scoreboardDetails={moduleScoreboard} isVideoVisibleToUser={false} isWriteUpsVisible={false} />
          </Container>
        </StyledMainContentOuter>}
      <MainContent rooms={rooms} prerequisites={prerequisites ?? []} nextSteps={nextSteps ?? []} isCtfModule={ctf} isMitreAssignmentModule={mitreAssignment} data-sentry-element="MainContent" data-sentry-source-file="module.tsx" />
    </>;
};